import { render, staticRenderFns } from "./driver-tags.vue?vue&type=template&id=b926dfae"
import script from "./driver-tags.vue?vue&type=script&lang=js"
export * from "./driver-tags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports